import { render, staticRenderFns } from "./MediaShop.vue?vue&type=template&id=3a35657a"
import script from "./MediaShop.vue?vue&type=script&lang=js"
export * from "./MediaShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports